import { connect } from 'react-redux'
import Dashboard from './Dashboard'
import { getDashboardData, updateSelectedPhysicianId } from './module'
import { handleOnPatientClick as handleOnPatientFileNavClick } from '../../pages/PatientFile/module'
import { handleOnNavClick as handleOnEkgReviewInboxClick } from '../../pages/EkgReview/module'
import { getDataSource } from '../../store/appReducer'
import { DATASOURCES } from '../../constants'

const mapActionCreators = {
  getDashboardData,
  updateSelectedPhysicianId,
  handleOnPatientFileNavClick,
  handleOnEkgReviewInboxClick,
}

const mapStateToProps = state => {
  const { dashboard } = state

  return {
    dataIsFetching: dashboard.dataIsFetching,
    dataLastUpdated: dashboard.dataLastUpdated,
    selectedPhysicianId: dashboard.selectedPhysicianId,
    me: getDataSource(state, DATASOURCES.ME),
    physicians: getDataSource(state, DATASOURCES.PHYSICIANS),
    overview: getDataSource(state, DATASOURCES.OVERVIEW),
    activity: getDataSource(state, DATASOURCES.ACTIVITY),
    ekgStackCounts: getDataSource(state, DATASOURCES.EKG_STACK_COUNTS),
  }
}

export default connect(
  mapStateToProps,
  mapActionCreators,
)(Dashboard)



// WEBPACK FOOTER //
// ./src/legacy/pages/Dashboard/container.js